/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIAddress } from './APIAddress';
import {
    APIAddressFromJSON,
    APIAddressFromJSONTyped,
    APIAddressToJSON,
} from './APIAddress';

/**
 * 
 * @export
 * @interface APIContractAutocompleteSuggestion
 */
export interface APIContractAutocompleteSuggestion {
    /**
     * 
     * @type {string}
     * @memberof APIContractAutocompleteSuggestion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof APIContractAutocompleteSuggestion
     */
    requestCertificate?: string;
    /**
     * 
     * @type {number}
     * @memberof APIContractAutocompleteSuggestion
     */
    contractStatus?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIContractAutocompleteSuggestion
     */
    contractStatusDisplay?: string;
    /**
     * 
     * @type {string}
     * @memberof APIContractAutocompleteSuggestion
     */
    contactName?: string;
    /**
     * 
     * @type {APIAddress}
     * @memberof APIContractAutocompleteSuggestion
     */
    shippingAddress?: APIAddress | null;
    /**
     * 
     * @type {APIAddress}
     * @memberof APIContractAutocompleteSuggestion
     */
    billingAddress?: APIAddress | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIContractAutocompleteSuggestion
     */
    articleNumbers?: Array<string>;
}

/**
 * Check if a given object implements the APIContractAutocompleteSuggestion interface.
 */
export function instanceOfAPIContractAutocompleteSuggestion(value: object): value is APIContractAutocompleteSuggestion {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function APIContractAutocompleteSuggestionFromJSON(json: any): APIContractAutocompleteSuggestion {
    return APIContractAutocompleteSuggestionFromJSONTyped(json, false);
}

export function APIContractAutocompleteSuggestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIContractAutocompleteSuggestion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'requestCertificate': json['request_certificate'] == null ? undefined : json['request_certificate'],
        'contractStatus': json['contract_status'] == null ? undefined : json['contract_status'],
        'contractStatusDisplay': json['contract_status_display'] == null ? undefined : json['contract_status_display'],
        'contactName': json['contact_name'] == null ? undefined : json['contact_name'],
        'shippingAddress': json['shipping_address'] == null ? undefined : APIAddressFromJSON(json['shipping_address']),
        'billingAddress': json['billing_address'] == null ? undefined : APIAddressFromJSON(json['billing_address']),
        'articleNumbers': json['article_numbers'] == null ? undefined : json['article_numbers'],
    };
}

export function APIContractAutocompleteSuggestionToJSON(value?: APIContractAutocompleteSuggestion | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'request_certificate': value['requestCertificate'],
        'contract_status': value['contractStatus'],
        'contract_status_display': value['contractStatusDisplay'],
        'contact_name': value['contactName'],
        'shipping_address': APIAddressToJSON(value['shippingAddress']),
        'billing_address': APIAddressToJSON(value['billingAddress']),
        'article_numbers': value['articleNumbers'],
    };
}

